"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _default = function _default(string, comparatorString) {
  var lowerCaseComparatorString = comparatorString.toLowerCase();

  if (comparatorString === '' || string.toLowerCase().indexOf(lowerCaseComparatorString) === -1) {
    return string;
  }

  var regexString = "(".concat(lowerCaseComparatorString, ")");
  var regexp = new RegExp(regexString, 'gi');
  var arr = string.split(regexp);
  return arr.map(function (chunk, i) {
    // eslint-disable-next-line react/no-array-index-key
    if (chunk.toLowerCase() === lowerCaseComparatorString) return /*#__PURE__*/_react["default"].createElement("b", {
      key: string + i
    }, chunk);
    return chunk;
  });
};

exports["default"] = _default;